import axios from 'axios';
import { Helpers } from '../helpers/Helpers';
import { AddStorageRequest } from '../models/request/storage/AddStorageRequest';
import { GetStorageListPagingAndFilterRequest } from '../models/request/storage/GetStorageListPagingAndFilterRequest';

export class StorageService {
    static async getStorageList() {
        try {
            var inputObj = {

            };

            console.log('SERVICE CALL - getStorageList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Storage/getStorageList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async exportStorageList(inputObj: GetStorageListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - exportStorageList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Storage/exportStorageList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getStorageListPagingAndFilter(inputObj: GetStorageListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - GetStorageListPagingAndFilter', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Storage/GetStorageListPagingAndFilter', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async addStorage(inputObj: AddStorageRequest) {
        try {
            console.log('SERVICE CALL - AddStorage', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Storage/AddStorage', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async deleteStorage(_ids: string[]) {
        try {
            var inputObj = {
                ids: _ids
            };

            console.log('SERVICE CALL - deleteStorage', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Storage/deleteStorage', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getStorageById(_id: string) {
        try {
            var inputObj = {
                id: _id
            };

            console.log('SERVICE CALL - getStorageById', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Storage/getStorageById', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }
}